import React from "react"
import Loadable from "react-loadable"

// component
import Loader from "components/Stacker/components/Loader/Loader"

const LoadableComponent = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "pdp" */ "components/Stacker/components/ProductDetailsPage/ProductDetailsPage.jsx"
    ),
  loading: Loader,
  render(loaded, props) {
    const DefaultComponent = loaded.default
    return <DefaultComponent {...props} />
  },
})

export default function LoadingProductDetailsPage(props) {
  return <LoadableComponent {...props} />
}
